import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TopNavModule } from 'elements-lib';
import { EntityDirective } from './directives/entity/entity.directive';
import { LabelDirective } from './directives/label/label.directive';
import { RectDirective } from './directives/rect/rect.directive';
import { RelationDirective } from './directives/relation/relation.directive';
import { EntityGroupComponent } from './entity-group/entity-group.component';
import { EntityComponent } from './entity/entity.component';
import { MetaModule } from './meta/meta.module';
// import { TopNavModule } from 'projects/elements-lib/src/lib/top-nav/top-nav.module';
import { RelationLabelsComponent } from './relation-labels/relation-labels.component';
import { RelationComponent } from './relation/relation.component';
import { SectionComponent } from './section/section.component';
import { SelectorsModule } from './selectors/selectors.module';
import * as fromVisualizer from './store';
import { ConceptEffects } from './store/concept/concept.effects';
import { EntityEffects } from './store/entity/entity.effects';
import { OntologiesEffects } from './store/ontologies/ontologies.effects';
import { RelationEffects } from './store/relation/relation.effects';
import { SectionEffects } from './store/section/section.effects';
import { SpanEffects } from './store/span/span.effects';
import { VisualizerEffects } from './store/visualizer/visualizer.effects';
import { VisualizerComponent } from './visualizer.component';


@NgModule({
  declarations: [
    VisualizerComponent,
    SectionComponent,
    EntityComponent,
    RelationComponent,
    EntityGroupComponent,
    RectDirective,
    EntityDirective,
    RelationDirective,
    LabelDirective,
    RelationLabelsComponent,
  ],
  imports: [
    CommonModule,
    TopNavModule,
    SelectorsModule,
    MetaModule,
    StoreModule.forFeature(fromVisualizer.visualizerFeatureKey, fromVisualizer.reducers, { metaReducers: fromVisualizer.metaReducers }),
    EffectsModule.forFeature([EntityEffects, SectionEffects, ConceptEffects, OntologiesEffects, RelationEffects, VisualizerEffects, SpanEffects])
  ],
  exports: [
    VisualizerComponent
  ]
})
export class VisualizerModule {}
